import API from '../utils/api';

export const getSellerDetailsById = async sellerId => {
  return API.get(`/admin/get/seller/${sellerId}`);
};

export const deleteseller = async sellerId => {
  return API.post(`/admin/seller/inactive/${sellerId}`);
};

export const updateSellerStatus = async (sellerId, statusPayload = {}) => {
  return API.post(`/admin/seller/status-update/${sellerId}`, statusPayload);
};

export const getKYCList = async sellerId => {
  return API.get(`/food/seller/services/get/seller/kyc/${sellerId}`);
};

export const kycApproval = async (sellerId, kycStatusData) => {
  return API.post(`/admin/seller/approval-status/${sellerId}`, kycStatusData)
    .then(response => response)
    .catch(error => error);
};

export const getPaymentModes = async countryId => {
  return API.get(`/payment/payment-modes?country_id=${countryId}`);
};

export const updateSellerDiscount = async (sellerId, discountPayload = {}) => {
  return API.post(
    `/admin/seller/ef-discount-update/${sellerId}`,
    discountPayload
  );
};

export const uploadMultipleDishes = async data => {
  return API.post(`/seller/add-multiple-dishes`, data);
};
